// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4578":"adf0b621","7811":"30206da5"}[chunkId] + ".chunk.css";
};